import { createSelector } from 'reselect';

export const getLoadingOrganization = state => state.organization && state.organization.loading;
export const getOrganizations = state => state.organization && state.organization.organizations;

export const getAllOrganizations = createSelector(
  getOrganizations,
  organizations => organizations && organizations.ids.map(id => organizations.entities[id])
);



// WEBPACK FOOTER //
// ./src/selectors/organization.js